import React from 'react';
import {CgArrowsHAlt} from "react-icons/cg"
import {MdFlipCameraIos} from "react-icons/md"
import {AiOutlineDelete} from "react-icons/ai"
class ImageEditor extends React.Component {
    
    constructor(props) {
        super(props);
        this.onFlipClicked=this.onFlipClicked.bind(this);
        this.onRemoveItemClicked=this.onRemoveItemClicked.bind(this);
    }
    onFlipClicked(){
        const {props}=this.props;
        if(props.designer.showFrontView){
            props.setFrontCanvasJson(JSON.stringify(props.designer.drawingCanvas));
            props.designer.drawingCanvas.clear();
            props.designer.drawingCanvas.loadFromJSON(props.designer.backCanvasJson)}
        else{
            props.setBackCanvasJson(JSON.stringify(props.designer.drawingCanvas));
            props.designer.drawingCanvas.clear();
            props.designer.drawingCanvas.loadFromJSON(props.designer.frontCanvasJson)
            
        }
        props.onFlipImageClicked();
    }

    onRemoveItemClicked(){

        const {props}=this.props;
        var canvas =props.designer.drawingCanvas;
        var activeObject = canvas.getActiveObject();
        if (activeObject) {
        canvas.remove(activeObject);
        props.decreasePrice();
        document.getElementById('remove-selected').style.visibility="hidden";

    }
    }

    render() {
        const {onZoomClicked}=this.props;
        return (
            <div id="imageeditor"> 
        <div id="imageEditorButton">										      
        <button id="flip" title="Flip Image" onClick={this.onFlipClicked}><span><img src='/Assets/icons/rotateshirt.png'/></span></button>
        <button id="remove-selected" style={{visibility:'hidden'}} onClick={this.onRemoveItemClicked} title="Delete selected item"><span><AiOutlineDelete size={35} color='grey'/></span></button>
    </div>
    
    </div> );
    }
}
 
export default ImageEditor;
// const ImageEditor = ({onZoomClicked,props}) => {
//     console.error(props);
//     return (
//         <div id="imageeditor"> 
//     <div id="imageEditorButton"  style={{zIndex:"1"}}>										      
//     <button className='rounded-circle' id="bring-to-front" title="Bring to Front"><i className="icon-fast-backward rotate" style={{height:"17px"}}></i></button>
//     <button className='rounded-circle' id="send-to-back" title="Send to Back"><i className="icon-fast-forward rotate" style={{height:"17px"}}></i></button>
//     <button className='rounded-circle'id="flip" type="button"  title="Show Back View" onClick={()=>{if(props.designer.showFrontView){props.setFrontCanvasJson(JSON.stringify(props.designer.drawingCanvas));props.designer.drawingCanvas.loadFromJson(props.designer.back)}else{props.setBackCanvasJson(JSON.stringify(props.designer.drawingCanvas))};props.onFlipImageClicked();}}><i className="icon-retweet" style={{height:"17px"}}></i></button>
//     <button className='rounded-circle' id="remove-selected" title="Delete selected item"><i className="icon-trash" style={{height:"17px"}}></i></button>
// </div>
// <button id="mobileZoomButton"onClick={()=>onZoomClicked()} style={{visibility:"hidden"}} className='rounded-circle'  title="Delete selected item"><CgArrowsHAlt size={20} /></button>

// </div> );
// }
 
// export default ImageEditor;